export default __webpack_public_path__ + "static/media/category4.79f0e545.png";